module.exports = __webpack_public_path__ + "img/jtmrfx.8ed36be9.png";